export enum PerformanceReviewPageEventName {
  UserEntersPerformanceReviewPage = 'userEntersPerformanceReviewPage'
}

export type PerformanceReviewPageEvent = {
  name: PerformanceReviewPageEventName.UserEntersPerformanceReviewPage
}
